import React from 'react';
import { getIconClassName } from '@uifabric/styling';
import { MiniIcons } from 'owa-mini-icons';

const styles = require('./SelectAllIcon.scss');
const classNames = require('classnames/bind').bind(styles);

interface SelectAllIconProps {
    isAllSelected?: boolean;
    classNames?: boolean;
}

export const SelectAllIcon: React.FC<SelectAllIconProps> = props => (
    <i
        className={classNames(
            styles.selectAllIcon,
            props.isAllSelected && styles.isAllSelected,
            'ms-Icon',
            getIconClassName(MiniIcons.CheckMark)
        )}
    />
);
